/**
 * 支払方法変更可否チェックAPI
 * レスポンス - レスポンス業務エリア
 */

export interface Sgkd048aResponseDto {
  /** 受付可能フラグ：真偽値 */
  aceptAbleFlg?: boolean;
}
